module.exports = __webpack_public_path__ + "img/bg-bottom-right.4af6f710.webp";